import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from '../../../material.module';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';


@Component({
  selector: 'app-advisor',
  imports: [TablerIconsModule, MaterialModule, CommonModule, MatDatepickerModule, RouterModule],
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],
  templateUrl: './advisor.component.html',
  styleUrl: './advisor.component.scss'
})
export class AdvisorComponent {
  selectmethod: string = ''
  selectedvalue: string = "yes";
  checktracking: boolean = true;
  constructor(public dialog: MatDialog) { }
  editmode: boolean = false;
  edit() {
    this.editmode = true;
  }
  cancel() {
    this.editmode = false;
  }
}
